import { propertyAmenitiesQueryKeys as e } from "./usePropertyAmenitiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertyAmenitiesApi as r } from "@maat/api-main";
//#region src/propertyAmenities/useCreatePropertyAmenity.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: async (e) => r.createPropertyAmenity(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreatePropertyAmenity };
